<span
  class="tw-whitespace-nowrap tw-rounded-full tw-px-3 tw-py-0.5 tw-text-xs tw-font-medium"
  [ngClass]="
    isManual
      ? 'tw-bg-color-surface-sunken tw-text-color-text-secondary'
      : 'tw-bg-color-status-success-bg tw-text-color-status-success-text'
  "
  >{{ (isManual ? "manualCategories" : "systemCategories") | i18n }}</span
>
